import { Pipe, PipeTransform } from '@angular/core';

import { DeviceLicense, DeviceLicenseWarningDetails } from '@shure/shared/angular/data-access/system-api/models';
import { DeviceLicenseStateTextService } from '@shure/shared-angular-features-device-license-utils';

@Pipe({ name: 'licenseStateDescriptionPipe', pure: true, standalone: true })
export class LicenseStateDescriptionPipe implements PipeTransform {
	constructor(private readonly deviceLicenseStateTextService: DeviceLicenseStateTextService) {}

	/* istanbul ignore next */
	public transform(deviceLicense: DeviceLicense<DeviceLicenseWarningDetails>): string {
		return this.deviceLicenseStateTextService.getDescription(deviceLicense);
	}
}
